var browserHistory;
jQuery(document).ready(function() {
  // Getting value of token from request parameter.
  var phoneorder_token = getParameterByName('token');
  if(phoneorder_token && phoneorder_token != null){
    jQuery.ajax({
      dataType: "json",
      url: "https://shopifyapi.dbuytest.info/api/verify-token-permission",
      cache: false,
      method: 'GET',
      beforeSend: function(request) {
        request.setRequestHeader("Authorization", "Bearer"+phoneorder_token);
      },
      success: function(response) {
        // Checking if phone order session exists or not.
        var phoneorder_session = sessionStorage.getItem("phoneorder-token");
        if(phoneorder_session != "") {
          sessionStorage.removeItem("phoneorder-token");
        }
        sessionStorage.setItem("phoneorder-token", phoneorder_token);
        // Checking if checkout is allowed or not.
        if(response.is_checkout_allowed == "false" || response.is_checkout_allowed == false) {
          var is_checkout_allowed = sessionStorage.getItem("is-checkout-allowed");
          if(is_checkout_allowed != "") {
            sessionStorage.removeItem("is-checkout-allowed");
          }
          sessionStorage.setItem("is-checkout-allowed", "no");
        }
        window.location.href = "http://" + window.location.hostname;
      } //success close  
    }); //ajax close
  }

  // Append loader to body
  jQuery('body').prepend('<div id="dividebuy-shipping-loader" class="dividebuy-loader-set" style="margin:0;display: none">'+
    '<div id="dividebuy-loader"></div>'+
  '</div>');
  
  // Append popup to body
  jQuery('body').prepend('<div class="dividebuy-softcredit">'+
    '<div id="dividebuy_modal_softcredit_search" class="modal fade dividebuy-modal custom-modal soft-search dividebuy-soft-search">'+
      '<div class="modal-dialog modal-lg">'+
        '<div class="modal-header clearfix">'+
          '<a href="javascript:void(0);" id="softcredit-scroll"  data-dismiss="modal" class="close shopify_close">X</a>'+
        '</div>'+
        '<div class="modal-content" style="overflow:hidden">'+
          '<div class="modal-body clearfix">'+
            '<div class="popup">'+
              '<div id="shipping-loader-softsearch" class="dividebuy-loader-set" style="margin:0;display: none">'+
                '<div id="dividebuy-loader"></div>'+
              '</div>'+
            '</div>'+
          '</div>'+
        '</div>'+
      '</div>'+
    '</div>'+
  '</div>');

  //check order is cancel than get back the dividebuy products to cart
  var url = window.location.href; 
  if(window.location.href.indexOf("?") > -1)
  {
    // spliting the data if query string is there
    var pieces = url.split("?");
    var cancelFlag = pieces[1].split("=");
    if(cancelFlag[0] == 'cancel') {
      jQuery("html").addClass('loader-on');
      jQuery("#dividebuy-shipping-loader").show();
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://shopifyapi.dbuytest.info/api/cancel-order-products?splashKey="+cancelFlag[1],
        "method": "GET",
        "headers": {
          "content-type": "application/json",
        },
        "processData": false,
      }
      jQuery.ajax(settings).done(function (response) {
          if(response.status == 'ok')
          {
          var _array = response.products;
          var addAjaxes     = [];
          jQuery.each(_array, function( key, value ) {
              var addAjax = jQuery.ajax({
              method  : 'post',
              url   : '/cart/add.js',
              data  : {
                  quantity: _array[key].qty,
                  id: _array[key].id
              }

              });
              addAjaxes.push(addAjax);
          });//add ajax close
          jQuery.when(addAjaxes).then(function(){
              setTimeout(function() { location.href = '/cart';  }, 5000);  
          });
          localStorage.clear();
          }else{
          alert("There is something went wrong with cart.");
          return false;
          }
      }).fail(function(){
        alert("There is something went wrong with cart.");
        return false;
      });
    }
  }
});

// Function for getting parameter name from request URL
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* Only functions*/

// Unserialize data from jquery
function unserialize (data) {
  var $global = (typeof window !== 'undefined' ? window : global)
  var utf8Overhead = function (str) {
    var s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
      var code = str.charCodeAt(i)
      if (code > 0x7f && code <= 0x7ff) {
        s++
      } else if (code > 0x7ff && code <= 0xffff) {
        s += 2
      }
      // trail surrogate
      if (code >= 0xDC00 && code <= 0xDFFF) {
        i--
      }
    }
    return s - 1
  }
  var error = function (type, msg, filename, line) {
    throw new $global[type](msg, filename, line)
  }
  var readUntil = function (data, offset, stopchr) {
    var i = 2
    var buf = []
    var chr = data.slice(offset, offset + 1)

    while (chr !== stopchr) {
      if ((i + offset) > data.length) {
        error('Error', 'Invalid')
      }
      buf.push(chr)
      chr = data.slice(offset + (i - 1), offset + i)
      i += 1
    }
    return [buf.length, buf.join('')]
  }
  var readChrs = function (data, offset, length) {
    var i, chr, buf
    buf = []
    for (i = 0; i < length; i++) {
      chr = data.slice(offset + (i - 1), offset + i)
      buf.push(chr)
      length -= utf8Overhead(chr)
    }
    return [buf.length, buf.join('')]
  }
  function _unserialize (data, offset) {
    var dtype
    var dataoffset
    var keyandchrs
    var keys
    var contig
    var length
    var array
    var readdata
    var readData
    var ccount
    var stringlength
    var i
    var key
    var kprops
    var kchrs
    var vprops
    var vchrs
    var value
    var chrs = 0
    var typeconvert = function (x) {
      return x
    }

    if (!offset) {
      offset = 0
    }
    dtype = (data.slice(offset, offset + 1)).toLowerCase()

    dataoffset = offset + 2

    switch (dtype) {
      case 'i':
        typeconvert = function (x) {
          return parseInt(x, 10)
        }
        readData = readUntil(data, dataoffset, ';')
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 1
        break
      case 'b':
        typeconvert = function (x) {
          return parseInt(x, 10) !== 0
        }
        readData = readUntil(data, dataoffset, ';')
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 1
        break
      case 'd':
        typeconvert = function (x) {
          return parseFloat(x)
        }
        readData = readUntil(data, dataoffset, ';')
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 1
        break
      case 'n':
        readdata = null
        break
      case 's':
        ccount = readUntil(data, dataoffset, ':')
        chrs = ccount[0]
        stringlength = ccount[1]
        dataoffset += chrs + 2
        readData = readChrs(data, dataoffset + 1, parseInt(stringlength, 10))
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 2
        if (chrs !== parseInt(stringlength, 10) && chrs !== readdata.length) {
          error('SyntaxError', 'String length mismatch')
        }
        break
      case 'a':
        readdata = {}
        keyandchrs = readUntil(data, dataoffset, ':')
        chrs = keyandchrs[0]
        keys = keyandchrs[1]
        dataoffset += chrs + 2
        length = parseInt(keys, 10)
        contig = true
        for (i = 0; i < length; i++) {
          kprops = _unserialize(data, dataoffset)
          kchrs = kprops[1]
          key = kprops[2]
          dataoffset += kchrs
          vprops = _unserialize(data, dataoffset)
          vchrs = vprops[1]
          value = vprops[2]
          dataoffset += vchrs
          if (key !== i) {
            contig = false
          }
          readdata[key] = value
        }
        if (contig) {
          array = new Array(length)
          for (i = 0; i < length; i++) {
            array[i] = readdata[i]
          }
          readdata = array
        }
        dataoffset += 1
        break
      default:
        error('SyntaxError', 'Unknown / Unhandled data type(s): ' + dtype)
        break
    }
    return [dtype, dataoffset - offset, typeconvert(readdata)]
  }
  return _unserialize((data + ''), 0)[2]
}

/* Checking the IP Shopify is not supporting this feature to get ip directly*/
function CheckIP(IpData)
{
  if(IpData == '0' || IpData == '') {
    jQuery('.dividebuy_logo_section').show();  
    return true;
  }

  jQuery.getJSON("http://jsonip.com/?callback=?", function (data) {
    var IpArray = IpData.split(',');
    var flag = "";
    jQuery.each( IpArray , function( key, value ) {
      if(value == data.ip ){
        flag = 1;
      }
    });   
    if(flag == 1){
      jQuery('.dividebuy_logo_section').show();
      jQuery('.softcredit').show();
    }   
  });
}

/* forinstallment tooltip*/
function GetInstallmentData(serializedata,Dprice){
  var html = '';
  var disable ='';
  var Divideprice = Dprice;
  for(value in serializedata ){
    var compare_price = serializedata[value].value;
    if( Divideprice < compare_price)
    {
      disable = 'hover-disable';
    }
    var month = serializedata[value].key;
    var divideratio = (Divideprice/month).toFixed(2);
    var totalprice = (Divideprice).toFixed(2);
    totalprice = totalprice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    divideratio = divideratio.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    html += '<div class="hover-instalment '+disable+'">';
    html += '<div class="highlights-instalments blue-text">'+month +' </div>';
    html += '<div class="monthly-instalments">monthly instalments of </div>';
    html += '<div class="highlights-amt blue-text"> Â£'+divideratio+' = </div>';
    html += '<div class="highlights-amt green-text"> Â£'+totalprice+'</div>';
    html +=  '<div class="clearfix"></div>'
    html +=  '</div>';
  }
  return(html);
}

// close popup jquery
function closePopup() {
  jQuery("html").addClass('loader-on');
  jQuery('html,body').animate({
    scrollTop: jQuery('#test').css('top')
    }, 800, function () {
      jQuery('html, body').animate({
        scrollTop: 0
      }, 800);
  });
  jQuery('#dividebuy_modal').removeClass('in-modal');
  jQuery('body').removeClass('dividebuy-modal');
  setTimeout(function() { jQuery("#dividebuy_modal").css("display","none"); }, 500);        
  jQuery(".loader-set").css('display', 'block');
  setTimeout(function () {
    location.reload();
  }, 5000);
}

// close popup jquery
function closeSoftCreditPopup() {
  jQuery('#dividebuy_modal_softcredit_search').removeClass('in-modal');
  jQuery('body').removeClass('dividebuy-modal-open');
  jQuery("#frame-dividebuy-softcredit-check").remove();
  setTimeout(function() { jQuery("#dividebuy_modal_softcredit_search").css("display","none"); }, 500);
  if(window.localStorage.getItem("browserHistory") !== null ) {
    browserHistory = window.localStorage.getItem("browserHistory");
    window.localStorage.removeItem("browserHistory");
    window.history.go(browserHistory - history.length);
  }
}

/* shipping codes */
function checkPostCode (toCheck) {
  // Permitted letters depend upon their position in the postcode.
  var alpha1 = "[abcdefghijklmnoprstuwyz]";                       // Character 1
  var alpha2 = "[abcdefghklmnopqrstuvwxy]";                       // Character 2
  var alpha3 = "[abcdefghjkpmnrstuvwxy]";                         // Character 3
  var alpha4 = "[abehmnprvwxy]";                                  // Character 4
  var alpha5 = "[abdefghjlnpqrstuwxyz]";                          // Character 5
  var BFPOa5 = "[abdefghjlnpqrst]";                               // BFPO alpha5
  var BFPOa6 = "[abdefghjlnpqrstuwzyz]";                          // BFPO alpha6

  // Array holds the regular expressions for the valid postcodes
  var pcexp = new Array ();

  // BFPO postcodes
  pcexp.push (new RegExp ("^(bf1)(\\s*)([0-6]{1}" + BFPOa5 + "{1}" + BFPOa6 + "{1})$","i"));

  // Expression for postcodes: AN NAA, ANN NAA, AAN NAA, and AANN NAA
  pcexp.push (new RegExp ("^(" + alpha1 + "{1}" + alpha2 + "?[0-9]{1,2})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

  // Expression for postcodes: ANA NAA
  pcexp.push (new RegExp ("^(" + alpha1 + "{1}[0-9]{1}" + alpha3 + "{1})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

  // Expression for postcodes: AANA  NAA
  pcexp.push (new RegExp ("^(" + alpha1 + "{1}" + alpha2 + "{1}" + "?[0-9]{1}" + alpha4 +"{1})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

  // Exception for the special postcode GIR 0AA
  pcexp.push (/^(GIR)(\s*)(0AA)$/i);

  // Standard BFPO numbers
  pcexp.push (/^(bfpo)(\s*)([0-9]{1,4})$/i);

  // c/o BFPO numbers
  pcexp.push (/^(bfpo)(\s*)(c\/o\s*[0-9]{1,3})$/i);

  // Overseas Territories
  pcexp.push (/^([A-Z]{4})(\s*)(1ZZ)$/i);  

  // Anguilla
  pcexp.push (/^(ai-2640)$/i);

  // Load up the string to check
  var postCode = toCheck;

  // Assume we're not going to find a valid postcode
  var valid = false;

  // Check the string against the types of post codes
  for ( var i=0; i<pcexp.length; i++) {
    if (pcexp[i].test(postCode)) {
      // The post code is valid - split the post code into component parts
      pcexp[i].exec(postCode);
      // Copy it back into the original string, converting it to uppercase and inserting a space 
      // between the inward and outward codes
      postCode = RegExp.$1.toUpperCase() + " " + RegExp.$3.toUpperCase();
      // If it is a BFPO c/o type postcode, tidy up the "c/o" part
      postCode = postCode.replace (/C\/O\s*/,"c/o ");
      // If it is the Anguilla overseas territory postcode, we need to treat it specially
      if (toCheck.toUpperCase() == 'AI-2640') {postCode = 'AI-2640'};
      // Load new postcode back into the form element
      valid = true;
      // Remember that we have found that the code is valid and break from loop
      break;
    }
  }

  // Return with either the reformatted valid postcode or the original invalid postcode
  if (valid) {return postCode;} else return "";
}

// For auto formating the zipcode on key press
jQuery(document).bind('DOMNodeInserted', function() {
  jQuery("#user_postcode").keyup(function () {
    var newPostCode = checkPostCode(document.getElementById('user_postcode').value);
    if (newPostCode) {
      document.getElementById('user_postcode').value = newPostCode;
    }
  });
});

// looking for scroll class
function updateTable() {
  if(jQuery('body').find('.shopping-scroll').length > 1 || jQuery('body').find('.cs-scroll').length > 0) {
    loadScript();
  } else {
    setTimeout(updateTable, 1000);
  }
}
updateTable();

// Loading the script
function loadScript() {
  setTimeout(function() { jQuery(".popup #dividebuy-shipping-loader").hide(); }, 6000);
}

// getting the order amount
function getOrderAmount(serializeData) {
  var _sarray = [];
  for(value in serializeData ) {
    _sarray[value] = serializeData[value].value;    
  } 
  var minValueInstall = Math.min.apply(Math,_sarray); 
  return minValueInstall;
}

// Code for loading iFrame of soft credit search
function displayCreditPopup(softsearchSplashKey, page) {
  jQuery('#dividebuy_modal_softcredit_search').css('display', 'block');
  jQuery('#dividebuy_modal_softcredit_search').addClass('in-modal');
  jQuery('body').addClass('dividebuy-modal-open');
  jQuery(".popup #shipping-loader-softsearch").show();
  jQuery("#frame-dividebuy-softcredit-check").remove();
  var iframeSrc = "https://softsearch.dividebuy.co.uk?splashKey="+softsearchSplashKey;
  if(page == "checkout") {
    iframeSrc = iframeSrc + "&isShopify=1&customerEmail=" + jQuery(".review-block__inner .review-block__content bdo").val();	
  }
  jQuery("#dividebuy_modal_softcredit_search").find(".modal-content").append(`<iframe tabindex="3" frameborder="0" id="frame-dividebuy-softcredit-check" src="${iframeSrc}" width="100%" class="frame"></iframe>`);
  var iframe = document.getElementById("frame-dividebuy-softcredit-check");
  if (iframe.attachEvent) {
    iframe.attachEvent("onload", function () {
      setTimeout(function() {
        window.localStorage.setItem("browserHistory", history.length - 1 );
        jQuery(".popup #shipping-loader-softsearch").hide();
      }, 3000);
    });
  } else {
    iframe.onload = function () {
      setTimeout(function() {
        window.localStorage.setItem("browserHistory", history.length - 1 );
        jQuery(".popup #shipping-loader-softsearch").hide();
      }, 3000);
    };
  }
}

window.addEventListener('message', receiver, false);
function receiver(e) {
  if (e.data == 'soft-search-popup-close') {
    closeSoftCreditPopup();
  }
  if(e.data == "soft-search-popup-back") {
    if(jQuery("#frame-dividebuy-softcredit-check").length > 0) {
      jQuery('#dividebuy_modal_softcredit_search').removeClass('in-modal');
      jQuery("body").removeClass('dividebuy-modal-open');
      jQuery("#frame-dividebuy-softcredit-check").remove();
      setTimeout(function() { jQuery("#dividebuy_modal_softcredit_search").css("display","none"); }, 500);
      if (window.localStorage.getItem("browserHistory") !== null) {	
        browserHistory = window.localStorage.getItem("browserHistory");	
        window.localStorage.removeItem("browserHistory");	
        window.history.go(browserHistory - history.length);	
      }
    }        
  }
  if(e.data == 'isShopify') {
    // close popup
    closeSoftCreditPopup();
    // call go to checkout function
    jQuery('#checkout_payment_gateway_33848590447').trigger('click');
    jQuery('.shown-if-js .step__footer__continue-btn').trigger('click');
  }
  if (e.data.isHeight) {
    jQuery('#frame-dividebuy-softcredit-check').height(e.data.isHeight);
  }
}

// Go to history if user reloaded page while softsearch popup was open.	
window.onload = function(event) {	
  console.log("huhuhu")
  if (window.localStorage.getItem("browserHistory") !== null) {
    console.log(" is in ")
    browserHistory = window.localStorage.getItem("browserHistory");	
    window.localStorage.removeItem("browserHistory");	
    window.history.go(browserHistory - history.length);	
  }
  jQuery('.loadingScreen').fadeOut(function(){

  });
}

// Code for close the tooltip, outside the container
jQuery(document).mouseup(function(e) {
  var container = jQuery(".dividebuy-tooltip");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.hide();
  }
});

// Code for close the tooltip, on the press of esc.
jQuery( document ).on('keydown', function ( e ) {
  var container = jQuery(".dividebuy-tooltip");
  if ( e.keyCode === 27 ) { // ESC
    container.hide();
  }
});

// Dispalying tooltip content based on image height on product page
function tooltipPosition(){
  var tooltipAnchorImage = document.getElementById('dividebuy-softsearch-text');
  var windowInnerHeight = window.innerHeight;
  var tooltipAnchorBottom = tooltipAnchorImage.getBoundingClientRect().bottom;
  var tooltipContentWrapperHeight = 0;
  var tooltipPosition = 'bottom';
  document.querySelector('.dividebuy-tooltip').style.display = 'block';
  tooltipContentWrapperHeight = document.querySelector(".dividebuy-tooltip");
  tooltipContentWrapperHeight = tooltipContentWrapperHeight.clientHeight;
  document.querySelector('.dividebuy-tooltip').style.display = 'none';

  // Getting banner height
  var imageBanner = document.querySelector("#dividebuy_image_after_cart #dividebuy-text");
  var bannerHeight = imageBanner.clientHeight;
  if (tooltipContentWrapperHeight + tooltipAnchorBottom > windowInnerHeight) {
    tooltipPosition = 'top';
  }
  if (tooltipPosition == 'bottom') {
    // Getting DivideBuy text and softsearch text offset
    var dividebuy_image_offset = jQuery('#dividebuy_image_after_cart').offset().top;
    var dividebuy_softsearch_offset = jQuery('#dividebuy-softsearch-text').offset().top;
    jQuery('.dividebuy-tooltip').css({
      'top': jQuery('#dividebuy-softsearch-text').innerHeight() + (dividebuy_softsearch_offset - dividebuy_image_offset) + 4,
      'bottom' : 'auto'
    });
  } else {
    jQuery('.dividebuy-tooltip').css({
      'bottom': bannerHeight + 6,
      'top' : 'auto'
    });
  }
  jQuery(".tooltip-db").fadeIn('fast');
}
function tooltipPositionDesktop(){
  var tooltipAnchorImage = document.querySelectorAll('#dividebuy-softsearch-text');
  var windowInnerHeight = window.innerHeight;
  var tooltipAnchorBottom = tooltipAnchorImage[1].getBoundingClientRect().bottom;
  var tooltipContentWrapperHeight = 0;
  var tooltipPosition = 'bottom';
  document.querySelector('.dividebuy-tooltip').style.display = 'block';
  tooltipContentWrapperHeight = document.querySelectorAll(".dividebuy-product-tooltip");
  tooltipContentWrapperHeight = tooltipContentWrapperHeight[1].clientHeight;
  document.querySelector('.dividebuy-tooltip').style.display = 'none';

  // Getting banner height
  var imageBanner = document.querySelectorAll("#dividebuy_image_after_cart #dividebuy-text");
  var bannerHeight = imageBanner[1].clientHeight;
  if (tooltipContentWrapperHeight + tooltipAnchorBottom > windowInnerHeight) {
    tooltipPosition = 'top';
  }
  if (tooltipPosition == 'bottom') {
    // Getting DivideBuy text and softsearch text offset
    var dividebuy_image_offset = jQuery('.tooltip-width.dividebuy-calculator').eq(1).offset().top;
    var dividebuy_softsearch_offset = jQuery('.link-dividebuy-softsearch').eq(1).offset().top
    jQuery('.dividebuy-tooltip').css({
      'top': jQuery('.link-dividebuy-softsearch').eq(1).innerHeight() + (dividebuy_softsearch_offset - dividebuy_image_offset) + 4,
      'bottom' : 'auto'
    });
  } else {
    jQuery('.dividebuy-tooltip').css({
      'bottom': bannerHeight + 6,
      'top' : 'auto'
    });
  }
  jQuery(".tooltip-db").fadeIn('fast');
}